import { IMenuItem } from "./ISidnavbar";
import { IconButton, SvgIcon, Typography } from "@mui/material";
import { ReactComponent as Dashboard } from "../../Assets/Images/Dashboard.svg";
import { ReactComponent as Settings } from "../../Assets/Images/Settings.svg";
import { ReactComponent as UserPermission } from "../../Assets/Images/UserPermission.svg";
import { ReactComponent as UserMaster } from "../../Assets/Images/UserMaster.svg";
import Avatars from "../Avatar/Avatars";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as Exam } from "../../Assets/Images/Exam.svg";
import { ReactComponent as Menuicon } from "../../Assets/Images/Menu.svg";
import { ReactComponent as Instruction } from "../../Assets/Images/instruction.svg";
import { ReactComponent as Masters } from "../../Assets/Images/Masters.svg";
import { ReactComponent as QuestionType } from "../../Assets/Images/QuestionType.svg";
import { ReactComponent as YearGroup } from "../../Assets/Images/QuestionType.svg";
import { ReactComponent as question } from "../../Assets/Images/Questions.svg";
import { ReactComponent as ExamModel } from "../../Assets/Images/ExamModel.svg";
import { ReactComponent as options } from "../../Assets/Images/options.svg";
import { ReactComponent as Usericon } from "../../Assets/Images/Role.svg";
import { ReactComponent as Dashboardicon } from "../../Assets/Images/Dashboard.svg";
import { ReactComponent as Cousres } from "../../Assets/Images/Courses.svg";
import { ReactComponent as Package } from "../../Assets/Images/PackageUser.svg";
import { ReactComponent as User } from "../../Assets/Images/Userpackage.svg";
import { ReactComponent as History } from "../../Assets/Images/History.svg";
import { ReactComponent as HistoryClock } from "../../Assets/Images/clock (1).svg";
import { ReactComponent as Examprogess } from "../../Assets/Images/Examprogess.svg";
import { ReactComponent as FullLengthMockExam } from "../../Assets/Images/FullLengthMockExam.svg";
import { ReactComponent as MiniMockExam } from "../../Assets/Images/MiniMockExam.svg";
import { ReactComponent as PracticeTest } from "../../Assets/Images/PracticeTest.svg";
import { ReactComponent as Videopage } from "../../Assets/Images/video.svg";
import { ReactComponent as Settingpage } from "../../Assets/Images/Setting.svg";
import { ReactComponent as Skilltrainer } from "../../Assets/Images/skilltrainer.svg";
import { ReactComponent as Dashboarduser } from "../../Assets/Images/Dashboarduser.svg";
import { ReactComponent as Chat } from "../../Assets/Images/chat with eliot.svg";
import { ReactComponent as Support } from "../../Assets/Images/support.svg";
import { ReactComponent as BookIcon } from "../../.MODULS/BOOKLET_MODUL/assets/images/study-material.svg";
import { ReactComponent as AssignmentIcon } from "../../.MODULS/BOOKLET_MODUL/assets/images/my-request.svg";
import { ReactComponent as EventNoteIcon } from "../../.MODULS/BOOKLET_MODUL/assets/images/lesson-plan.svg";
import { ReactComponent as ShoppingCartOutlinedIcon } from "../../.MODULS/BOOKLET_MODUL/assets/images/cart.svg";

// managment

export const menu: { [key: string]: IMenuItem[] } = {
  Dashboard: [
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Dashboard",
      to: "admindashboard",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Dashboard",
      to: "tutor_dashboard",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Dashboard",
      to: "tutor_admin_dashboard",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Dashboard",
      to: "crm_dashboard",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={ExamModel} inheritViewBox />,
      title: "Booklet Request",
      to: "booklet_request",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
    },

    {
      icon: <SvgIcon component={ExamModel} inheritViewBox />,
      title: "Booklet Request Details",
      to: "booklet_request/details",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: false,
      },
    },

    {
      icon: <SvgIcon component={User} inheritViewBox />,
      title: "leads",
      to: "leads",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
    },

    {
      icon: <SvgIcon component={YearGroup} inheritViewBox />,
      title: "Session",
      to: "session",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
    },

    {
      icon: <SvgIcon component={User} inheritViewBox />,
      title: "Users",
      to: "userprofile",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
      items: [
        {
          icon: <SvgIcon component={Usericon} inheritViewBox />,
          title: "Student",
          to: "userprofile/student",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Masters} inheritViewBox />,
          title: "Staff",
          to: "userprofile/staff",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
      ],
    },
    {
      icon: <SvgIcon component={Masters} inheritViewBox />,
      title: "Masters",
      to: "masters",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
      items: [
        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Center",
          to: "masters/center",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },

        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Center Printer",
          to: "masters/center_printer",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },
        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Printer",
          to: "masters/printer",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },
        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Subject Drive Map",
          to: "masters/subject_drive_map",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },
        {
          icon: <SvgIcon component={Exam} inheritViewBox />,
          title: "Class Selection",
          to: "masters/class_selection",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={User} inheritViewBox />,
          title: "Tutors",
          to: "masters/tutors",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },

        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Year Group",
          to: "masters/yeargroup",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Video Upload",
          to: "masters/video_upload",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={QuestionType} inheritViewBox />,
          title: "Question Type",
          to: "masters/questiontype",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={QuestionType} inheritViewBox />,
          title: "Question SubType",
          to: "masters/questionsubtype",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={question} inheritViewBox />,
          title: "Questions",
          to: "masters/questions",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Exam Model",
          to: "masters/exammodel",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Exam} inheritViewBox />,
          title: "Exam",
          to: "masters/exam",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Exam} inheritViewBox />,
          title: "Practice Exam",
          to: "masters/practiceexam",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Cousres} inheritViewBox />,
          title: "Courses",
          to: "masters/courses",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Package} inheritViewBox />,
          title: "Package",
          to: "masters/package",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Package} inheritViewBox />,
          title: "Assign Package",
          to: "masters/assignpackage",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Subject",
          to: "masters/subject",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Sub topic",
          to: "masters/subtopic",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Content",
          to: "masters/content",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Country",
          to: "masters/country",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Country wise year level",
          to: "masters/yearlevel",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={YearGroup} inheritViewBox />,
          title: "Competitive Exams",
          to: "masters/examdate",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={ExamModel} inheritViewBox />,
          title: "Template",
          to: "masters/template",
          permissions: {
            add: true,
            delete: true,
            edit: true,
            view: true,
            show: true,
          },
        },
      ],
    },

    {
      icon: <SvgIcon component={Settings} inheritViewBox />,
      title: "Settings",
      to: "settings",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
      items: [
        {
          icon: <SvgIcon component={Usericon} inheritViewBox />,
          title: "Role",
          to: "settings/role",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Menuicon} inheritViewBox />,
          title: "Screen",
          to: "settings/screen",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
          {
          icon: <SvgIcon component={Menuicon} inheritViewBox />,
          title: "Role Mapping master",
          to: "settings/role-mapping-master",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={Menuicon} inheritViewBox />,
          title: "Menu",
          to: "settings/menu",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
        {
          icon: <SvgIcon component={UserPermission} inheritViewBox />,
          title: "User Permission",
          to: "settings/userPermission",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
         {
          icon: <SvgIcon component={UserPermission} inheritViewBox />,
          title: "Role Permission",
          to: "settings/role_permission",
          permissions: {
            add: true,
            view: true,
            show: true,
            edit: true,
            delete: true,
          },
        },
      ],
    },

    // Student page
    {
      icon: <SvgIcon component={Dashboarduser} inheritViewBox />,
      title: "Instruction",
      to: "instruction",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "StudyMaterials_Topic",
      to: "study_materials/topic",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "StudyMaterials_Subtopic",
      to: "study_materials/sub-topic",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboarduser} inheritViewBox />,
      title: "Dashboard",
      to: "dashboard",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Skilltrainer} inheritViewBox />,
      title: "Skills Trainer",
      to: "skillstrainer",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "Practice Test",
      to: "practicetest",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "UCAT Test",
      to: "ucat_test",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
         {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "Ucat Test review",
      to: "ucat_test_review",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
      {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "UCAT test evaluation",
      to: "/ucat_testevaluation",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "Mini Mock Exam",
      to: "minimockexam",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "Mock Exam",
      to: "mockexam",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    // {
    //   icon: <SvgIcon component={Cousres} inheritViewBox />,
    //   title: "Courses",
    //   to: "mainexam",
    //   permissions: {
    //     add: true,
    //     view: true,
    //     show: true,
    //     edit: true,
    //     delete: true,
    //   },
    // },
    {
      icon: <SvgIcon component={History} inheritViewBox />,
      title: "Exam in Progress",
      to: "examprogress",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={History} inheritViewBox />,
      title: "Exam History",
      to: "examhistory",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Videopage} inheritViewBox />,
      title: "Video Tutorials",
      to: "tutorials",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Videopage} inheritViewBox />,
      title: "Video Lessons",
      to: "videolessons",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Skilltrainer} inheritViewBox />,
      title: "Study Notes",
      to: "studynote",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Skilltrainer} inheritViewBox />,
      title: "Topic",
      to: "topic",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Skilltrainer} inheritViewBox />,
      title: "Sub Topic",
      to: "subtopic",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Skilltrainer} inheritViewBox />,
      title: "Content",
      to: "content",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={UserPermission} inheritViewBox />,
      title: "My Enrollments",
      to: "totalexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={UserPermission} inheritViewBox />,
      title: "Memory",
      to: "memorygame",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={UserPermission} inheritViewBox />,
      title: "Arithmetic Game",
      to: "arithmetic-game",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={UserPermission} inheritViewBox />,
      title: "videolesson details",
      to: "videolessondetails",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={UserPermission} inheritViewBox />,
      title: "videolesson details",
      to: "videolessondetails",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Videopage} inheritViewBox />,
      title: "Video Topic",
      to: "videolessonstopic",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Chat} inheritViewBox />,
      title: "Chat with Elliot",
      to: "chatbotelliot",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "Class Selection",
      to: "class_selection",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={BookIcon} inheritViewBox />,
      title: "Study Materials",
      to: "study_materials",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={ShoppingCartOutlinedIcon} inheritViewBox />,
      title: "Cart",
      to: "study_materials/cart",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={AssignmentIcon} inheritViewBox />,
      title: "My Request",
      to: "my_requests",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={EventNoteIcon} inheritViewBox />,
      title: "Lesson Plan",
      to: "lesson_plan",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={PracticeTest} inheritViewBox />,
      title: "My Request Details",
      to: "mmy_request/request_details",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={HistoryClock} inheritViewBox />,
      title: "History",
      to: "history",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
    },
    {
      icon: <SvgIcon component={Settingpage} inheritViewBox />,
      title: "Settings",
      to: "setting",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={History} inheritViewBox />,
      title: "History",
      to: "Booklet_history",
      permissions: {
        add: true,
        delete: true,
        edit: true,
        view: true,
        show: true,
      },
    },
    {
      icon: <SvgIcon component={Support} inheritViewBox />,
      title: "Support",
      to: "support",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Exam Participation",
      to: "examparticipation",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Practice Exam",
      to: "practiceexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Submit Exam",
      to: "submitexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Submit practice Exam",
      to: "submitexampractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Welcome_UCAT",
      to: "welcome_ucat",
      permissions: {
        add: true,
        view: true,
        show: true,
        edit: true,
        delete: true,
      },
    },
    // {
    //   icon: <SvgIcon component={Exam} inheritViewBox />,
    //   title: "Welcome UCAT",
    //   to: "ucat_welcome_screen",
    //   permissions: {
    //     add: true,
    //     view: true,
    //     show: true,
    //     edit: true,
    //     delete: true,
    //   }
    // },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "UCAT Test Instruction",
      to: "ucat_exampractice_instruction",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "UCAT Practice Test",
      to: "ucat_exam_practice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "UCAT Test Result",
      to: "ucat_examresult_practice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Feed Back",
      to: "feedback",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Feed Back Practice",
      to: "feedbackpractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Exam Result",
      to: "examresult",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Exam Result practice",
      to: "examresultpractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "ReView Exam ",
      to: "reviewexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "ReView Exam Practice ",
      to: "reviewexampractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Re Exam ",
      to: "reexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "instructionreExam",
      to: "instructionreExam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "subscribedPages",
      to: "subscribedPages",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Student Profile",
      to: "studentprofile",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Pending",
      to: "instructionpending",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "InstructionPendingPractice",
      to: "instructionpendingpractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },

    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Practice",
      to: "instructionpractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "PendingExam",
      to: "pendingexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Pendingexam Practice",
      to: "pendingexampractice",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
    {
      icon: <SvgIcon component={Dashboardicon} inheritViewBox />,
      title: "Purchasedexam",
      to: "purchasedexam",
      permissions: {
        add: true,
        view: true,
        show: false,
        edit: true,
        delete: true,
      },
    },
  ],
};

export const testMenu: IMenuItem[] = [
  {
    title: "Dashboard",
    to: "dashboard",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Users",
    to: "userprofile",
    permissions: {
      add: true,
      delete: true,
      edit: true,
      view: true,
      show: true,
    },
    items: [
      {
        title: "Student",
        to: "userprofile/student",
        permissions: {
          add: true,
          view: true,
          show: true,
          edit: true,
          delete: true,
        },
      },
      {
        title: "Menu",
        to: "userprofile/staff",
        permissions: {
          add: true,
          view: true,
          show: true,
          edit: true,
          delete: true,
        },
      },
    ],
  },
  {
    title: "Exam",
    to: "masters/exam",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },

  {
    title: "Questions",
    to: "masters/questions",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Package",
    to: "masters/package",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Courses",
    to: "masters/courses",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Question Type",
    to: "masters/questiontype",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Question SubType",
    to: "masters/questionsubtype",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "ExamModel",
    to: "masters/exammodel",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "practiceexam",
    to: "masters/practiceexam",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },

  {
    title: "Role",
    to: "settings/role",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Menu",
    to: "settings/menu",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "User Permission",
    to: "settings/userPermission",
    permissions: {
      add: true,
      view: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Dashboard",
    to: "instruction",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Dashboarduser",
    to: "home",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Dashboard",
    to: "examhistory",
    permissions: {
      add: true,
      view: true,
      show: true,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Exam Participation",
    to: "examparticipation",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Practice Exam",
    to: "practiceexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Submit Exam",
    to: "submitexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Feed Back",
    to: "feedback",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Feed Back Practice",
    to: "feedbackpractice",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Exam Result",
    to: "examresult",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "ReView Exam ",
    to: "reviewexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "ReView Exam Practice ",
    to: "reviewexampractice",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Re Exam ",
    to: "reexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "instructionreExam",
    to: "instructionreExam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "subscribedPages",
    to: "subscribedPages",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Total Exam",
    to: "totalexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Student Profile",
    to: "studentprofile",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Pending",
    to: "instructionpending",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "practice",
    to: "instructionpractice",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "InstructionPendingPractice",
    to: "instructionpendingpractice",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "PendingExam",
    to: "pendingexam",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
  {
    title: "Pendingexam Practice",
    to: "pendingexampractice",
    permissions: {
      add: true,
      view: true,
      show: false,
      edit: true,
      delete: true,
    },
  },
];

export const skipedMenu = [""];

export const notificationMenu = [
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
  {
    content: (
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Avatars></Avatars>
        <div style={{}}>
          <Typography component={"div"}>New Message from A</Typography>
          <Typography component={"p"} variant="body2">
            Feb 28 10:50 am
          </Typography>
        </div>
        <IconButton>
          <SvgIcon
            sx={{
              height: "20px",
              width: "20px",
            }}
            component={CloseIcon}
          />
        </IconButton>
      </div>
    ),
  },
];
